// extracted by mini-css-extract-plugin
module.exports = {"autoCode":"AutoCode_autoCode__PNA5b","autoCodeInput":"AutoCode_autoCodeInput__st3Iu"};